// read-workspace-get-pack-endpoint-override.ts
//
// Đọc override AVATAR_GET_PACK_ENDPOINT từ <workspace>/.claude/settings.json —
// tầng (b) trong precedence của getPackEndpoint. Workspace-level ONLY: KHÔNG đọc
// global ~/.claude. Tiện switch dev/prod theo workspace mà không phải export env.
//
// SYNC có chủ đích: getPackEndpoint() là sync (gọi trong fetchSignedPackUrl) nên
// dùng readFileSync thay vì readJson async của filesystem-helpers.
//
// Fail-SOFT: workspace không tìm thấy / file không tồn tại / JSON lỗi / thiếu key
// / value sai kiểu → trả undefined (caller fallback về default). Giá trị trả về
// vẫn phải qua validate HTTPS+whitelist ở getPackEndpoint — đây KHÔNG phải nguồn
// tin cậy.
import { readFileSync } from "node:fs";
import { resolveAvatarWorkspaceRootFromCwd } from "./resolve-avatar-workspace-root-from-cwd.js";
import { getClaudeSettingsPath } from "./write-claude-settings-json-per-project.js";

export function readWorkspaceGetPackEndpointOverride(): string | undefined {
  const workspace = resolveAvatarWorkspaceRootFromCwd(process.cwd());
  if (!workspace) return undefined;
  try {
    const raw = readFileSync(getClaudeSettingsPath(workspace), "utf8");
    const settings = JSON.parse(raw) as { env?: { AVATAR_GET_PACK_ENDPOINT?: unknown } };
    const value = settings.env?.AVATAR_GET_PACK_ENDPOINT;
    return typeof value === "string" ? value : undefined;
  } catch {
    return undefined; // file thiếu / JSON lỗi → bỏ qua tầng này, KHÔNG throw
  }
}
